var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "89px",
    viewBox: "0 0 69 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSketch: "http://www.bohemiancoding.com/sketch/ns",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dwelo-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    sketchType: "MSPage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dwelo-logo",
    sketchType: "MSArtboardGroup",
    fill: "#F6871E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.643,55.2130005 C12.643,67.9280005 22.296,77.4640005 34.54,77.4640005 C46.785,77.4640005 56.438,67.9280005 56.438,55.0960005 C56.438,42.2630005 46.785,32.7280005 34.54,32.7280005 C22.296,32.7280005 12.643,42.2630005 12.643,55.0960005 L12.643,55.2130005 Z M0.400000006,54.9780005 C0.400000006,37.9070005 12.997,21.1900005 34.54,21.1900005 C56.084,21.1900005 68.681,37.9070005 68.681,55.0960005 C68.681,72.2830005 56.084,88.8830005 34.54,88.8830005 C12.997,88.8830005 0.400000006,72.2830005 0.400000006,55.0960005 L0.400000006,54.9780005 Z",
    id: "Fill-1",
    sketchType: "MSShapeGroup"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3049835,0 L12.5200005,8.109 L12.5200005,17.126 L34.3049835,9.015 L56.4700012,17.198 L56.4700012,8.183 L34.3049835,0 Z",
    id: "Fill-4",
    sketchType: "MSShapeGroup"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1a45a68ad3a27849244425a7f8174f6e.svg";
export { ForwardRef as ReactComponent };